import { Check, Sparkles, X } from 'lucide-react'

export const Comparison = () => {
    const features = [
        { name: 'Theme swaps', free: '3/week', premium: 'Unlimited' },
        { name: 'Theme creations/remixes', free: '3 total', premium: 'Unlimited' },
        { name: 'Calendar sync', free: 'Next 3 days', premium: 'Unlimited' },
        { name: "Study tools in Canvas files", free: "Limited", premium: "Unlimited" },
        { name: "Lecture transcriptions", free: "Limited", premium: "Unlimited" },
    ]

    return (
        <>
            <div className="grid grid-cols-2 gap-4 md:gap-6">
                {/* Free Plan */}
                <div className="relative group">
                    <div className="relative bg-white/80 dark:bg-gray-900/80 backdrop-blur-sm border border-gray-200 dark:border-gray-700 rounded-2xl p-6 transition-all duration-300">
                        {/* Header */}
                        <div className="text-center mb-6">
                            <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-gray-100 dark:bg-gray-800 mb-3">
                                <X className="w-6 h-6 text-gray-600 dark:text-gray-400" />
                            </div>
                            <h3 className="text-lg font-bold text-gray-900 dark:text-gray-100">Free</h3>
                            <p className="text-xs text-gray-500 dark:text-gray-400 mt-3">Everything from OG BetterCanvas</p>
                        </div>

                        {/* Features */}
                        <div className="space-y-1">
                            {features.map((feature, idx) => (
                                <div key={idx} className="flex items-start gap-3 p-2 rounded-lg transition-colors">
                                    <div className="flex-shrink-0 w-5 h-5 rounded-full bg-gray-200 dark:bg-gray-700 flex items-center justify-center mt-0.5">
                                        <Check className="w-3 h-3 text-gray-600 dark:text-gray-400" strokeWidth={3} />
                                    </div>
                                    <div className="flex-1 min-w-0">
                                        <p className="text-sm font-medium text-gray-700 dark:text-gray-300">{feature.name}</p>
                                        <p className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">{feature.free}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                {/* Learn+ Plan */}
                <div className="relative group">
                    {/* Animated gradient background */}
                    <div className="absolute inset-0 bg-gradient-to-br from-orange-500 to-pink-500 rounded-2xl opacity-75 blur-sm" />
                    
                    <div className="relative bg-white/95 dark:bg-gray-900/95 backdrop-blur-sm rounded-2xl p-6 transition-all duration-300">
                        {/* Popular badge */}
                        <div className="absolute -top-3 left-1/2 -translate-x-1/2">
                            <div className="bg-brand-gradient text-white text-xs font-bold px-4 py-1 rounded-full shadow-lg">
                                ✨ TRIAL ACTIVE
                            </div>
                        </div>

                        {/* Header */}
                        <div className="text-center mb-6 mt-0">
                            <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-brand-gradient mb-3 shadow-lg">
                                <Sparkles className="w-6 h-6 text-white" strokeWidth={2.5} />
                            </div>
                            <h3 className="text-lg font-bold underline decoration-wavy decoration-orange-600 decoration-2 underline-offset-4">
                                Learn+
                            </h3>
                            <p className="text-xs text-gray-600 dark:text-gray-400 mt-3">Power up your learning</p>
                        </div>

                        {/* Features */}
                        <div className="space-y-1">
                            {features.map((feature, idx) => (
                                <div 
                                    key={idx} 
                                    className="flex items-start gap-3 p-2 rounded-lg hover:bg-orange-50 dark:hover:bg-orange-900/10 transition-colors"
                                >
                                    <div className="flex-shrink-0 w-5 h-5 rounded-full bg-gradient-to-br from-orange-500 to-pink-500 flex items-center justify-center mt-0.5 shadow-sm">
                                        <Check className="w-3 h-3 text-white" strokeWidth={3} />
                                    </div>
                                    <div className="flex-1 min-w-0">
                                        <p className="text-sm font-medium text-gray-900 dark:text-gray-100">{feature.name}</p>
                                        <p className="text-xs font-semibold text-orange-600 dark:text-orange-400 mt-0.5">{feature.premium}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}